/**
 * Design system typography – aligned with Ag style guide (Heading/Quote/Body/Label).
 * Font names match expo-google-fonts.
 *
 * Headings: Ag Heading 24 (24/26), 20 (20/22), 18 (18/20) – Cairo Bold
 * Quotes: Ag Quote 24, 20, 18 – Lora Regular
 * Body: Ag Body 18 (18/20), 16 (16/18), 14 (14/16), 12 (12/Auto) – Open Sans
 * Label: Ag Label 16 (16/18), 14 (14/16), 12 (12/14) – Cairo Semibold
 */

import type { TextStyle } from 'react-native'

export const headlineFont = 'Cairo_700Bold'
const quoteFont = 'Lora_400Regular'
const bodyFont = 'OpenSans_400Regular'
const labelFont = 'Cairo_600SemiBold'

export const headline1: TextStyle = {
  fontFamily: headlineFont,
  fontSize: 24,
  fontWeight: 'bold',
}
export const headline2: TextStyle = {
  fontFamily: headlineFont,
  fontSize: 20,
  fontWeight: 'bold',
}
export const headline3: TextStyle = {
  fontFamily: headlineFont,
  fontSize: 18,
  fontWeight: 'bold',
}

export const quote1: TextStyle = {
  fontFamily: quoteFont,
  fontSize: 24,
  fontWeight: 'regular',
}
const quote2: TextStyle = {
  fontFamily: quoteFont,
  fontSize: 20,
  fontWeight: 'regular',
}
export const quote3: TextStyle = {
  fontFamily: quoteFont,
  fontSize: 18,
  fontWeight: 'regular',
}

export const body1: TextStyle = {
  fontFamily: bodyFont,
  fontSize: 18,
  letterSpacing: 0.4,
  fontWeight: 'regular',
}
export const body2: TextStyle = {
  fontFamily: bodyFont,
  fontSize: 16,
  letterSpacing: 0.4,
  fontWeight: 'regular',
}
export const body3: TextStyle = {
  fontFamily: bodyFont,
  fontSize: 14,
  letterSpacing: 0.4,
  fontWeight: 'regular',
}
export const body4: TextStyle = {
  fontFamily: bodyFont,
  fontSize: 12,
  letterSpacing: 0.4,
  fontWeight: 'regular',
}

export const label1: TextStyle = {
  fontFamily: labelFont,
  fontSize: 16,
  fontWeight: 'semibold',
}

/** Label 16 — Cairo 600, line-height 100%, letter-spacing 0. */
export const label1Tight: TextStyle = {
  fontFamily: labelFont,
  fontSize: 16,
  fontWeight: '600',
  lineHeight: 16,
  letterSpacing: 0,
}
export const label2: TextStyle = {
  fontFamily: labelFont,
  fontSize: 14,
  fontWeight: 'semibold',
}
export const label3: TextStyle = {
  fontFamily: labelFont,
  fontSize: 12,
  fontWeight: 'semibold',
}

export const typography = {
  headline1,
  headline2,
  headline3,
  quote1,
  quote2,
  quote3,
  body1,
  body2,
  body3,
  body4,
  label1,
  label1Tight,
  label2,
  label3,
} as const
